import { useEffect } from 'react';
import type { Direction } from '../../domain/game/types';
import { gameStore } from '../../store/gameStore';

const KEY_TO_DIR: Record<string, Direction> = {
  ArrowUp: 'NORTH',
  KeyW: 'NORTH',
  ArrowDown: 'SOUTH',
  KeyS: 'SOUTH',
  ArrowLeft: 'WEST',
  KeyA: 'WEST',
  ArrowRight: 'EAST',
  KeyD: 'EAST',
};

/** WASD / arrows → store.moveByDir when not in combat and not typing in inputs. */
export function useExplorationKeyboard(): void {
  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      const direction = KEY_TO_DIR[event.code];
      if (!direction) {
        return;
      }

      const target = event.target;
      if (
        target instanceof HTMLElement &&
        (target.tagName === 'INPUT' ||
          target.tagName === 'TEXTAREA' ||
          target.isContentEditable)
      ) {
        return;
      }

      const { mode, player } = gameStore.getState();
      if (!player.alive || mode.type === 'combat' || mode.type === 'dead') {
        return;
      }

      event.preventDefault();
      gameStore.getState().moveByDir(direction);
    };

    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, []);
}
